import { isNotNullish } from '@adornis/assert/isNullish.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { subscribeByID } from '@adornis/baseql/operations/mongo.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { of } from 'rxjs';
import { Person } from '../../users/entities/person.js';
import { HistoryAPI } from '../api/HistoryAPI.js';
import { HistoryTimeline } from './HistoryTimeline.js';

/** The group's own changes together with those of every booking it ever had, each booking named by its person. */
export const SgGroupTimeline = stateful((props: { groupID: Maybe<string> }) => {
  const { value: bookings, loading } = useQuery(
    () => (props.groupID ? HistoryAPI.subscribeGroupBookings(props.groupID)({ _id: 1, userID: 1 }) : of([])),
    [props.groupID],
  );

  const userIDs = [...new Set(bookings?.map(booking => booking.userID).filter(isNotNullish))];
  const { value: persons } = useQuery(
    () => subscribeByID(Person, userIDs)({ _id: 1, profilDaten: { stammdaten: { vorname: 1, nachname: 1 } } }),
    [userIDs.join(';')],
  );

  const names = new Map(
    persons?.map(person => [
      person._id,
      `${person.profilDaten?.stammdaten?.vorname ?? '---'} ${person.profilDaten?.stammdaten?.nachname ?? '---'}`,
    ]),
  );
  // a booking whose person is gone still shows as a booking
  const references = new Map(
    bookings?.map(booking => [booking._id, `Buchung von ${names.get(booking.userID ?? '') ?? '---'}`]),
  );

  return HistoryTimeline({
    documentIDs: props.groupID ? [props.groupID, ...(bookings?.map(booking => booking._id) ?? [])] : [],
    loading,
    resolveReference: event => references.get(event.documentID ?? ''),
  });
});
